import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

const PaymentResponse = ({ order_id, fetchPaymentRequestDetails }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    fetchPaymentRequestDetails();
  }, []);

  return (
    <section className="transaction-section">
      <div className="container theme-section">
        <h1 className="tr-title text-center"> Payment </h1>

        <div className="tr-center-box">
          <div>
            <p className="tr-note">{searchParams.get("response_message")}</p>

            <div className="multiple-btn">
              <Link to={`/order/details/${order_id}`}>
                <button> Go Back To Order Detail </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(PaymentResponse);
